import Cleave from 'cleave.js';

export class ProfileForm {
    constructor(el) {
        this.phone_number = document.querySelector('#telemedicine_intakes_v2_on_demand_identities_profile_form_phone');
        new Cleave(this.phone_number, {
            numericOnly: true,
            delimiter: '-',
            blocks: [3, 3, 4],
        });
        this.date_of_birth = document.querySelector('#dob');
        // Format MM/DD/YYYY
        new Cleave(this.date_of_birth, {
          date: true,
          datePattern: ['m', 'd', 'Y'],
          delimiter: '/'
        });
    }
}